<template>
  <div class="login">
    <div class="login1">
      <div>
        <h2 style="font-weight: 700;">會員登入</h2><br>
        <b-form-group id="input-group-1" label="帳號" label-for="input-1" style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;">
          <b-form-input id="input-1" v-model="email" required></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2" label="密碼" label-for="input-2" style="text-align: left; font-family: Helvetica; font-size: 20px; font-weight: 500;">
          <b-form-input id="input-2" type='password' v-model="password" v-on:keyup.enter="signIn" required></b-form-input>
        </b-form-group>
        <b-button @click="signIn" size="sm" type="submit" variant="primary" style="font-size: 15px;margin-top: 15px;">登入</b-button>
        <p>You don't have an account ? You can
      <router-link to="/signup">create one</router-link>
    </p>
      </div>

  </div>

  </div>
</template>
<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signIn: function () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
        function (user) {
          location.href = '/addactivities'
        },
        function (err) {
          alert('Opps. ' + err.message)
        }
      )
    }

  }
}

</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.login {
  background-color: rgba(248, 194, 88,0.1);
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15%;

}

/*html,body{
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
}*/
.login1 {
  margin-top: 100px;
  margin-bottom: 100px;
  width: 500px;
  height: 400px;
  background-color: rgba(#FFFFFF);
  border-radius: 10px;
  /*border: 5px solid #fff;*/
  box-shadow: 0 0 25px #aaa;
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}

</style>
